// Height of the sticky toolbar + filter bar region (ReportToolbar + ReportFilterBar inside
// StickyHeader), shared by everything that needs to position content directly below it —
// VirtualizedNestedList's sticky group headers, useSticky's IntersectionObserver threshold, and
// the SDA column-heading row. Previously duplicated as a literal `145` in both
// VirtualisedItemList.tsx and useSticky.ts; consolidated here so a future change to the toolbar's
// height doesn't have to be hunted down across files (raytd/web QA 108.03 items 17-18).
export const TOOLBAR_HEIGHT = 145;

// Height of an individual sticky group/category header row (report-group-header.tsx).
export const HEADER_HEIGHT = 44;

// Height of the sticky SDA column-heading row (sda-results-column-headings.tsx). Lives here
// rather than on that component so VirtualisedItemList.tsx can import it without pulling that
// component's own import graph (./test-tile -> comments-section.tsx -> ...) into its bundle —
// that graph isn't mocked in VirtualisedItemList's tests and broke them when tried.
export const SDA_COLUMN_HEADINGS_HEIGHT = 36;
